import React from "react";

class ApMobileApproveButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fillScreen: false };
  }
  render() {
    const { type, fileName } = this.props;

    let label = "";
    let icon = null;
    if (type === "approve") {
      icon = require("../../../media/icons/check-solid.svg");
      label = `Möchten Sie diese Seite von "${fileName}" wirklich freigeben?`;
    } else if (type === "reject") {
      icon = require("../../../media/icons/times-solid.svg");
      label = `Möchten Sie diese Seite von "${fileName}" wirklich ablehnen?`;
    }

    return (
      <div className="ApproveConfirmBtn">
        <p>{label}</p>
        <img
          alt="Confirm"
          src={icon}
          onClick={() => this.setState({ fillScreen: true })}
        />

        {this.state.fillScreen ? (
          <div className="ApproveConfirmBtnFill" />
        ) : null}
      </div>
    );
  }
}

export default ApMobileApproveButton;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileApproveButton.js